/**
 * @license
 * @copyright Copyright Motili Inc., 2023 All Rights Reserved
 */

import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FormCheckboxNoLabel from '../form/FormCheckboxNoLabel';

import styles from './Accordion.module.scss';

export default class Accordion extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isExpand: this.props.disabled ? true : this.props.isExpand,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isExpand !== this.props.isExpand) {
            this.setState({
                isExpand: this.props.isExpand,
            });
        }
    }

    render() {
        return (
            <div id={this.props.id} className={styles.accordionWrapper}>
                <div
                    id={`${this.props.id}-title`}
                    className={classNames({
                        [styles.accordionTitle]: true,
                        [styles.noSpace]: this.props.headerNoSpace,
                        [styles.noBorder]: this.props.noBorder,
                        [styles.open]: this.state.isExpand,
                    })}
                    style={{
                        backgroundColor: this.props.headerBackgroundColor
                            ? this.props.headerBackgroundColor
                            : '#FFFFFF',
                        border: this.props.headerBackgroundColor
                            ? '1px solid #D0D0D0'
                            : '1px solid #E4E4E4',
                        color: this.props.headerColor
                            ? this.props.headerColor
                            : '#000000',
                    }}
                >
                    {this.props.selected && (
                        <div className={styles.accordionSelectContent}>
                            <FormCheckboxNoLabel
                                controlId={this.props.selected.controlId}
                                checked={this.props.selected.isSelected}
                                onChange={e => {
                                    this.props.selected.handleSelected(
                                        e.target.checked
                                    );
                                }}
                                disabled={this.props.selected.disabled}
                            />
                        </div>
                    )}
                    <div
                        className={classNames({
                            [styles.accordionHeaderContent]: true,
                            [styles.noSpace]: this.props.headerNoSpace,
                            [styles.widthInherit]: this.props.headerNoSpace,
                            [styles.noPaddingRight]: this.props.headerNoSpace,
                        })}
                        onClick={() => {
                            if (!this.props.disabled) {
                                this.setState(
                                    { isExpand: !this.state.isExpand },
                                    () =>
                                        this.props.handleExpanded &&
                                        this.props.handleExpanded(
                                            this.state.isExpand
                                        )
                                );
                            }
                        }}
                    >
                        <div
                            className={classNames({
                                [styles.title]: true,
                                [styles.noPadding]: this.props.headerNoSpace,
                            })}
                        >
                            {this.props.title}
                        </div>
                    </div>
                    {this.props.toolbar && (
                        <div className={styles.toolbar}>
                            {this.props.toolbar}
                        </div>
                    )}
                    <div
                        className={styles.expandIcon}
                        onClick={() => {
                            if (!this.props.disabled) {
                                this.setState(
                                    { isExpand: !this.state.isExpand },
                                    () =>
                                        this.props.handleExpanded &&
                                        this.props.handleExpanded(
                                            this.state.isExpand
                                        )
                                );
                            }
                        }}
                    >
                        {this.state.isExpand ? (
                            <i className='fa fa-chevron-up' />
                        ) : (
                            <i className='fa fa-chevron-down' />
                        )}
                    </div>
                </div>
                {this.state.isExpand && (
                    <div
                        className={classNames({
                            [styles.accordionItem]: true,
                            [styles.collapsed]: !this.state.isExpand,
                        })}
                    >
                        <div
                            id={`${this.props.id}-content`}
                            className={styles.accordionContent}
                        >
                            {this.props.children}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

Accordion.propTypes = {
    id: PropTypes.string,
    title: PropTypes.object,
    toolbar: PropTypes.object,
    headerBackgroundColor: PropTypes.string,
    headerColor: PropTypes.string,
    headerNoSpace: PropTypes.bool,
    noBorder: PropTypes.bool,
    selected: PropTypes.shape({
        controlId: PropTypes.string.isRequired,
        isSelected: PropTypes.bool.isRequired,
        handleSelected: PropTypes.func.isRequired,
        disabled: PropTypes.bool,
    }),
    isExpand: PropTypes.bool,
    handleExpanded: PropTypes.func,
    disabled: PropTypes.bool,
};

Accordion.defaultProps = {
    isExpand: false,
    disabled: false,
    headerNoSpace: false,
    noBorder: false,
};
